import { render, staticRenderFns } from "./GhostWriterNav.vue?vue&type=template&id=e48535e4&scoped=true"
import script from "./GhostWriterNav.vue?vue&type=script&lang=js"
export * from "./GhostWriterNav.vue?vue&type=script&lang=js"
import style0 from "./GhostWriterNav.vue?vue&type=style&index=0&id=e48535e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48535e4",
  null
  
)

export default component.exports